import * as React from "react"
import NavBar from "../../components/NavBar";
import {useTranslation} from "react-i18next";
import {CheckCircle, Instagram, Phone, Telegram, Add} from '@mui/icons-material';
import LinkIcon from "@mui/icons-material/Link"
import {Box, Checkbox, CircularProgress, DialogContent} from "@mui/material";
import {useSearchParams, Link, useLocation} from "react-router-dom";


export default function AboutUS() {
  const {t} = useTranslation()
  const location = useLocation();


  return (
     <>
       <NavBar/>

       <div className="aboutPage">
         <div className="container">
           <div className="row">

             <div className="col-12 mb-4">
               <video width="100%" controls poster="/About-Us-Cover.jpg">
                 <source src="/about.mp4" type="video/mp4"/>
               </video>
             </div>

             <div className="col-12">
               <div className="about-title">
                 <span>{t("about.t1")}</span>

                 <div className="social">
                   <a href="https://www.postex.ir" target="_blank" className="item" id="postex">
                     <LinkIcon/>
                   </a>
                   <a href="tel:02191300250" className="item" id="phone">
                     <Phone/>
                   </a>
                   <a href="https://t.me/postex" target="_blank" className="item" id="telegram">
                     <Telegram/>
                   </a>
                   <a href="https://instagram.com/postex.ir" target="_blank" className="item" id="instagram">
                     <Instagram/>
                   </a>
                 </div>
               </div>
             </div>

             <div className="col-12 mb-4">
               <h2>{t("about.t2")}</h2>
               <p>{t("about.t3")}</p>
             </div>

             <div className="col-12 mb-4">
               <h5><CheckCircle htmlColor="#009BDE"/> {t("about.t4")}</h5>
               <p>{t("about.t5")}</p>
             </div>

             <div className="col-12 mb-4">
               <h5>{t("about.t6")}</h5>
               <p>{t("about.t7")}</p>
             </div>

             <div>
               <a href="https://postexgroup.com/" target="_blank" id="aboutus">{t("about.t10")}...</a>
             </div>

             <div className="col-12">
               <div className="_btnGroup_yellow">
                 <Link to={{pathname: '/singleOrder', search: location?.search}} type="button" className="btnFill" id="singleOrder">
                   <span>{t("about.t9")}</span>
                   <Add/>
                 </Link>
               </div>
             </div>

             <hr/>

             <div className="col-12 col-xl-4">
               <h2>{t("about.t8")}</h2>
             </div>

             <div className="col-6 col-md-6 col-lg-3 col-xl-2">
               <div className="item-social">
                 <a href="https://t.me/postex" target="_blank" id="telegram">t.me/postex</a>
                 <div className="item">
                   <Telegram/>
                 </div>
               </div>
             </div>
             <div className="col-6 col-md-6 col-lg-3 col-xl-2">
               <div className="item-social">
                 <a href="https://instagram.com/postex.ir" target="_blank" id="instagram">postex.ir</a>
                 <div className="item">
                   <Instagram/>
                 </div>
               </div>
             </div>
             <div className="col-6 col-md-6 col-lg-3 col-xl-2">
               <div className="item-social">
                 <a href="https://www.postex.ir" id="postex">postex.ir</a>
                 <div className="item">
                   <LinkIcon/>
                 </div>
               </div>
             </div>
             <div className="col-6 col-md-6 col-lg-3 col-xl-2">
               <div className="item-social">
                 <a href="tel:02191300250" id="phone">02191300250</a>
                 <div className="item">
                   <Phone/>
                 </div>
               </div>
             </div>


             <section className="news">
               <div className="container">
                 <div className="bg">
                   <div className="title">
                     <p>{t("homeDesktop.s6.t1")}</p>
                     <div dangerouslySetInnerHTML={{__html: t("homeDesktop.s6.t2")}}/>
                   </div>
                   <div className="input">
                     {/*<input type="text" placeholder={t("homeDesktop.s6.t3")}/>*/}
                     <a href="https://mag.postex.ir/" target="_blank" id="mag">
                       <button type="button">{t("homeDesktop.s6.t4")}</button>
                     </a>
                   </div>
                 </div>
               </div>
             </section>

           </div>
         </div>
       </div>

     </>
  )
}
